import { CheckCircleIcon, ChevronRightIcon } from '@/common/icons/arrows.tsx'
import LinkCard from '@/common/components/HorizontalLinkCard.tsx'
import {
  InformationIcon,
  LocationIcon,
  MenuIcon,
  ShopIcon,
  UserCheckIcon,
  UserSquareIcon,
} from '@/common/icons/general.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import {
  ApplicationSteps,
  useWizardContext,
} from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useCallback } from 'react'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useNavigate } from 'react-router-dom'
import { cn } from '@/common/utilities.ts'
import { useTranslation } from 'react-i18next'

const steps = [
  {
    title: 'location_declaration',
    status: true,
    route: AppRoutePaths.program_application.wizard.location_declaration.index,
    icon: LocationIcon,
  },
  {
    title: 'basic_information_title',
    status: true,
    route: AppRoutePaths.program_application.wizard.basic_info.index,
    icon: MenuIcon,
  },
  {
    title: 'poc_information',
    status: true,
    route: AppRoutePaths.program_application.wizard.poc_info.index,
    icon: UserSquareIcon,
  },
  {
    title: 'business_information',
    status: false,
    route: AppRoutePaths.program_application.wizard.business_info.index,
    icon: ShopIcon,
  },
  {
    title: 'supporting_documents',
    status: false,
    route: AppRoutePaths.program_application.wizard.service_info.index,
    icon: InformationIcon,
  },
  {
    title: 'consent_and_review',
    status: false,
    route: AppRoutePaths.program_application.wizard.consent_review.index,
    icon: UserCheckIcon,
  },
]

const VendorApplicationView = () => {
  const { t: translate } = useTranslation()
  const navigate = useNavigate()
  const { goNext } = useWizardContext()
  const { allStepData } = useWizardContext()

  let lastStepCompleted: number | null = null
  for (let index = allStepData.length - 1; index >= 0; index--) {
    if (allStepData[index].completed) {
      lastStepCompleted = allStepData[index].stepID
      break
    }
  }

  let target = null
  if (lastStepCompleted) {
    target = ApplicationSteps[lastStepCompleted]
  }
  const handleNextClick = useCallback(() => {
    if (target != null) {
      goNext(target)
    } else {
      goNext()
    }
  }, [lastStepCompleted])

  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>
          {translate('program_application_checklist')}
        </WizardStepTitle>
        <div className="pt-10 w-full max-w-xl mx-auto grid grid-cols-1 gap-4">
          {steps.map((step) => (
            <LinkCard
              key={step.title}
              className={cn(
                'border border-gray-300 hover:border-primary hover:bg-primary-50 hover:opacity-100',
                step.status && 'opacity-60'
              )}
              onClick={() => navigate(step.route)}
            >
              <LinkCard.Content>
                <div className="min-w-0 flex-1">
                  <div className={cn('flex items-center justify-between')}>
                    <div className="flex items-center space-x-2">
                      <step.icon className="text-xl" />
                      <p className="text-sm font-semibold">
                        {translate(step.title)}
                      </p>
                      {step.status && (
                        <CheckCircleIcon className="text-success text-md" />
                      )}
                    </div>
                    <ChevronRightIcon className="w-5 h-5 items-center" />
                  </div>
                </div>
              </LinkCard.Content>
            </LinkCard>
          ))}
        </div>
      </WizardBodyContainer>
      <WizardFooter
        onNext={handleNextClick}
        nextButtonText={
          lastStepCompleted != null ? translate('continue') : translate('start')
        }
      />
    </>
  )
}

export default VendorApplicationView
